var CSV = {};

// Note that provision of jQuery is optional (it is **only** needed if you use fetch on a remote file)
(function (my) {
  "use strict";
  my.__type__ = "csv";

  my.normalizeDialectOptions = function (options) {
    // note lower case compared to CSV DDF
    var out = {
      delimiter: ",",
      doublequote: true,
      lineterminator: "\n",
      quotechar: '"',
      skipinitialspace: true,
      skipinitialrows: 0,
    };
    for (var key in options) {
      if (key === "trim") {
        out["skipinitialspace"] = options.trim;
      } else {
        out[key.toLowerCase()] = options[key];
      }
    }
    return out;
  };

  my.objectToArray = function (dataToSerialize) {
    var a = [];
    var fieldNames = [];
    var fieldIds = [];
    let fieldGetters = {};
    for (var ii = 0; ii < dataToSerialize.fields.length; ii++) {
      var id = dataToSerialize.fields[ii].id;
      fieldIds.push(id);
      var label = dataToSerialize.fields[ii].label
        ? dataToSerialize.fields[ii].label
        : id;
      var getter = dataToSerialize.fields[ii].getter;
      if (getter) {
        fieldGetters[id] = getter;
      }
      fieldNames.push(label);
    }
    a.push(fieldNames);
    for (ii = 0; ii < dataToSerialize.records.length; ii++) {
      var tmp = [];
      var record = dataToSerialize.records[ii];
      for (var jj = 0; jj < fieldIds.length; jj++) {
        if (fieldGetters[fieldIds[jj]]) {
          tmp.push(fieldGetters[fieldIds[jj]](record));
        } else {
          tmp.push(record[fieldIds[jj]]);
        }
      }
      a.push(tmp);
    }
    return a;
  };

  // ## serialize
  //
  // See README for docs
  //
  // Heavily based on uselesscode's JS CSV serializer (MIT Licensed):
  // http://www.uselesscode.org/javascript/csv/
  my.serialize = function (dataToSerialize, dialect) {
    var a = null;
    if (dataToSerialize instanceof Array) {
      a = dataToSerialize;
    } else {
      a = my.objectToArray(dataToSerialize);
    }
    var options = my.normalizeDialectOptions(dialect);

    var cur = "", // The character we are currently processing.
      field = "", // Buffer for building up the current field
      row = "",
      out = "",
      i,
      j,
      processField;

    processField = function (field) {
      if (field === null) {
        // If field is null set to empty string
        field = "";
      } else if (typeof field === "string" && rxNeedsQuoting.test(field)) {
        if (options.doublequote) {
          field = field.replace(/"/g, '""');
        }
        // Convert string to delimited string
        field = options.quotechar + field + options.quotechar;
      } else if (typeof field === "number") {
        // Convert number to string
        field = field.toString(10);
      }

      return field;
    };

    for (i = 0; i < a.length; i += 1) {
      cur = a[i];

      for (j = 0; j < cur.length; j += 1) {
        field = processField(cur[j]);
        // If this is EOR append row to output and flush row
        if (j === cur.length - 1) {
          row += field;
          out += row + options.lineterminator;
          row = "";
        } else {
          // Add the current field to the current row
          row += field + options.delimiter;
        }
        // Flush the field buffer
        field = "";
      }
    }

    return out;
  };

  var // If a string has leading or trailing space,
    // contains a comma double quote or a newline
    // it needs to be quoted in CSV output
    rxNeedsQuoting = /^\s|\s$|,|"|\n/;
})(CSV);

if (typeof module !== "undefined" && module.exports) {
  module.exports = CSV;
}
